module.exports = __webpack_public_path__ + "static/headphones-top-banner-section-aae4631070627e5eb20eaf9acafdad5a.png";